import React from "react";
import Banner, {bannerStyle} from "@components/Banner";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import MegaphoneIcon from "../../../../icons/MegaphoneIcon";
import {IconX} from "@tabler/icons-react";
import {PresenzeFormValues} from "../FormDataUpdater";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {getWFTooltip} from "../../comps/EditGiustificativi";

interface BannersAnomalieProps {
    defaultValues: PresenzeFormValues,
    causaliWF: PresenzeCausaleWFRecord[],
    resetWarning: (warning: number) => void
}

export const BannersAnomalieWarnings: React.FC<BannersAnomalieProps> = ({
                                                                            defaultValues,
                                                                            causaliWF,
                                                                            resetWarning
                                                                        }) => {
    const warnings = PresenzeGiornataPlusRecord.getWarnings(defaultValues);
    const idWarnWF = 1024;
    const Header: React.FC<{ idWarn: number }> = ({idWarn}) => <span className="inline-flex w-full">
                                <MegaphoneIcon className="h-6 w-6"/>
                                <p className="ml-3 font-medium content-end">
                                    <span>{PresenzeGiornataPlusRecord.getDescrizioneWarning(idWarn)}</span>
                                </p>
                                <IconX className="ml-auto h-4 w-4" onClick={() => resetWarning(idWarn)}/>
                            </span>;
    return <div>
        {/* BANNERS ANOMALIE */}
        {PresenzeGiornataPlusRecord.hasAnomalia(defaultValues) &&
            <Banner style={bannerStyle.danger} text={PresenzeGiornataPlusRecord.getDescrizioneAnomalia(defaultValues)} className="mb-3"/>}

        {/* BANNERS WARNING (tranne quelli relativi al WF) */}
        {warnings.filter(warn => warn !== idWarnWF).map((warn, index) =>
            <Banner style={bannerStyle.warning} key={index}
                    className="flex flex-col mb-3 text-yellow-800">
                <div className="w-full">
                    <Header idWarn={warn}/>
                </div>
            </Banner>
        )}

        {/* BANNERS WARNING relativi al WF
        N.B. uso il map solo per comodità e uniformità con ciclo precedente, si tratta di un solo warning...
        */}
        {warnings.filter(warn => warn === idWarnWF).map((warn, index) =>
            <Banner style={bannerStyle.warning} key={index}
                    className="mb-3 text-yellow-800">
                <div className="flex flex-col w-full">
                    <div>
                        <Header idWarn={warn}/>
                    </div>
                    <div className="ml-6">
                        <ul className="" style={{listStylePosition: 'inside', listStyle: 'inside', listStyleType: 'initial'}}>
                            {causaliWF.map((causaleWF) =>
                                <a href="#" key={PresenzeCausaleWFRecord.getKey(causaleWF)} onClick={() => alert('Funzione "go2Monitor()" non implementata! #' + causaleWF.wf.idWF)}>
                                    <li className="mb-2">
                                        {getWFTooltip(causaleWF, causaleWF.wf.idWF)}
                                    </li>
                                </a>)}
                        </ul>
                    </div>
                </div>
            </Banner>
        )}

    </div>
};